import { createSlice } from "@reduxjs/toolkit";
import { getPostersByTenantId, updatePosterKey } from "./thunks";

export const POSTER_FETCH_LIMIT = 10;

const initialState = {
  posters: [],
  loading: true,
  allFetched: false,
};

const postersSlice = createSlice({
  name: "posters",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPostersByTenantId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPostersByTenantId.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.posters = [...state.posters, ...data];
        state.loading = false;
        if (data?.length < POSTER_FETCH_LIMIT) state.allFetched = true;
      })
      .addCase(getPostersByTenantId.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updatePosterKey.fulfilled, (state, action) => {
        const { url } = action.payload;
        const { poster_id } = action.meta.arg;
        const index = state.posters?.findIndex(({ id }) => id === poster_id);
        if (index !== -1) {
          state.posters[index].content = url;
        }
      });
  },
});

export const { setKeyValue } = postersSlice.actions;

export default postersSlice.reducer;
